import type ConversationResponseShape from 'owa-service/lib/contract/ConversationResponseShape';
import conversationResponseShape from 'owa-service/lib/factory/conversationResponseShape';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { getProactiveDraftExtendedPropertyUrisForRequest } from 'owa-proactive-drafts-shared';
import type ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import type PropertyUri from 'owa-service/lib/contract/PropertyUri';

const COMMON_PROPERTY_SET_GUID = '00062008-0000-0000-C000-000000000046';

export const FindConversationShapeName: string = 'ReactConversationListView';
const FindConversationSentItemsShapeName: string = 'ReactConversationSentItemsListView';
const FindConversationSearchFolderListView: string = 'ReactFindConversationSearchFolderListView';
/**
 * Gets find conversation response shape.
 * @returns The ConversationResponseShape
 */
export function getFindConversationResponseShape(folderId?: string): ConversationResponseShape {
    const additionalProperties: (PropertyUri | ExtendedPropertyUri)[] = [];
    if (folderId && folderIdToName(folderId) == 'scheduled') {
        additionalProperties.push(
            propertyUri({ FieldURI: 'ConversationReturnTime' }),
            propertyUri({ FieldURI: 'ConversationHashtags' })
        );
    }
    additionalProperties.push(...getProactiveDraftExtendedPropertyUrisForRequest());
    if (isGlobalFeatureEnabled('mon-copilot-daily-briefings')) {
        additionalProperties.push(
            extendedPropertyUri({
                PropertyName: 'CopilotGeneratedContent',
                PropertySetId: COMMON_PROPERTY_SET_GUID,
                PropertyType: 'String',
            })
        );
    }
    return conversationResponseShape({
        BaseShape: 'IdOnly',
        AdditionalProperties: additionalProperties.length > 0 ? additionalProperties : undefined,
    });
}

/**
 * Gets find conversation shape name based on the folder. The FindConversationSentItemsShapeName
 * shape gives back recipients whereas the ReactConversationListView gives back senders.
 * FindConversationSearchFolderListView gives the parent folder id for the conversation view.
 * @param folderId the folder for which we are going to do findConversation
 * @param isSearchFolderScenario boolean true if scenario type is of search folder (including some favorites)
 * @returns the shape name
 */
export function getFindConversationShape(
    folderId: string,
    isSearchFolderScenario: boolean
): string {
    const folderName = folderIdToName(folderId, true /* shouldSearchShared */);
    if (folderName == 'sentitems' || folderName == 'drafts') {
        return FindConversationSentItemsShapeName;
    } else if (isSearchFolderScenario) {
        return FindConversationSearchFolderListView;
    }
    return FindConversationShapeName;
}
